import React from 'react';
import './PracticeAreas.css'
import Cards from '../components/Cards';
import Subtitle from '../components/Subtitle';
import Title from '../components/Title';
import Paragraph from '../components/Paragraph';

const PracticeAreas = () => {
    return ( <>
    <div className='section3'>
        <div className='title-container-2'>
        <Subtitle text='Legal Services' css3='subtitle'/>
        <Title text2='Practice Areas' css6='text6'/>
        <div className='line2'></div>
        <Paragraph text2='Comprehensive legal expertise across multiple disciplines' css7='paragraph2'/>
        </div>
    <Cards />
    </div>
    </> );
}
 
export default PracticeAreas;